import {getWorkstationsByLocalId} from '../../../../../../crud/management_api/workstations';
import { getMenusByLocalId } from '../../../../../../crud/menu_api/menus';
import {
  getAllParentsCategoriesByLocalId
} from '../../../../../../crud/menu_api/categories';

export interface WorkstationOption {
    id: number;
    name: string;
}

export interface MenuOption {
    id: number;
    name: string;
}

export interface ParentCategoryOption {
  id: number;
  name: string;
}

/* _________________Get Function:_________________*/
export const getWorkstationsOptions = async () => {
  const userContext = localStorage.getItem('user');
  const localId = userContext != null ? JSON.parse(userContext).local_id : 0;
  const response = await getWorkstationsByLocalId(localId);
  if (response) {
    const data = response.data;
    if (data) {
      const workstations:WorkstationOption[] = data.map((workstation:any) => {
        return {
          id: workstation.workstation_id,
          name: workstation.workstation_name,
        };
      });
      return [{id:0,name:"Ninguno"},...workstations];
    }
  }
  return [];
}; 

export const getMenusOptions = async () => {
  const userContext = localStorage.getItem('user');
  const localId = userContext != null ? JSON.parse(userContext).local_id : 0;
  const response = await getMenusByLocalId(localId);
  if (response) {
    const data = response.data;
    if (data) {
      const menus:MenuOption[] = data.map((menu:any) => {
        return {
          id: menu.menu_id,
          name: menu.menu_name,
        };
      });
      return [{id:0,name:"Ninguno"},...menus];
    }
  }
  return [];
}; 

export const getParentCategoryOption = async (): Promise<ParentCategoryOption[]> => {
  const userContext = localStorage.getItem('user');
  const localId = userContext ? JSON.parse(userContext).local_id : 0;
  const response = await getAllParentsCategoriesByLocalId(localId);
  if (response && response.data) {
    const categories: ParentCategoryOption[] = response.data.map((category: any) => ({
      id: category.category_id,
      name: category.category_name,
    }));
    return [{ id: 0, name: "Ninguno" }, ...categories];
  }
  return [];
};